<template>
  <CRow>
    <div v-if="submitType === 'Update'">
      <CModal
          :title="
          submitType === 'Update'
            ? $lang.need_report.crud.edit
            : $lang.need_report.crud.create
        "
          size="lg"
          :show.sync="largeModal"
          :no-close-on-backdrop="true"
          color="primary"
      >
        <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
            err_msg
          }}
        </CAlert>
        <CForm novalidate @submit.prevent="onSubmit">
          <CCardBody>
            <div class="form-group" :class="{ 'form-group--error': '' }">
              <label class="form__label"
              >{{ $lang.need_report.form.reason }}
                <required_span/>
              </label>
              <v-select
                  :options="reasonOptions"
                  v-model="need_report.reason"
              ></v-select>
              <small
                  class="error"
                  v-if="
                  $v.need_report.reason.$error &&
                  !$v.need_report.reason.required
                "
              >
                {{ $lang.need_report.validation.required.reason }}
              </small>
            </div>
            <div class="form-group">
              <label class="form__label">{{
                  $lang.need_report.form.description
                }}</label>
              <textarea
                  class="form-control"
                  v-model="need_report.description"
              />
            </div>
          </CCardBody>
          <CCardFooter>
            <CButton
                type="submit"
                size="sm"
                color="primary"
                :disabled="submitted"
            >
              <CIcon name="cil-check-circle"/>
              {{ $lang.buttons.general.crud.submit }}
            </CButton>
          </CCardFooter>
        </CForm>
        <template #footer style="display: none">
          <CButton
              @click="darkModal = false"
              color="danger"
              style="display: none"
          >Discard
          </CButton
          >
          <CButton
              @click="darkModal = false"
              color="success"
              style="display: none"
          >Accept
          </CButton
          >
        </template>
      </CModal>
    </div>
    <div v-else>
      <CModal
          :title="
          submitType === 'Update'
            ? $lang.need_report.crud.edit
            : $lang.need_report.crud.view
        "
          size="lg"
          :show.sync="largeModal"
          :no-close-on-backdrop="true"
          color="primary"
      >
        <div class="form-group" :class="{ 'form-group--error': '' }">
          <label class="form__label">
            {{ $lang.need_report.form.reason }} :
          </label>
          <div>
            {{ need_report.reason.label }}
          </div>
        </div>
        <div class="form-group">
          <label class="form__label"
          >{{ $lang.need_report.form.description }} :
          </label>
          <div>
            {{ ViewResponse }}
          </div>
        </div>
        <template #footer style="display: none">
          <CButton
              @click="darkModal = false"
              color="danger"
              style="display: none"
          >Discard
          </CButton
          >
          <CButton
              @click="darkModal = false"
              color="success"
              style="display: none"
          >Accept
          </CButton
          >
        </template>
      </CModal>
    </div>
    <CCol col="12">
      <div class="row">
        <CCol sm="6" class="align-self-center"></CCol>
        <CCol sm="6" class="align-self-center">
          <div class="text-sm-right mt-3 mt-sm-0">
            <CButtonGroup class="file-export">
              <CButton color="secondary" disabled>
                {{ $lang.buttons.export.title }}
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.export.pdf"
                  v-on:click="
                  exports(self, 'pdf', module, 'Need Reports', self.editId)
                "
              >
                <i class="fas fa-file-pdf"></i>
              </CButton>
              <VueJsonToCsv
                  class="btn btn-success"
                  v-c-tooltip="$lang.buttons.export.excel"
                  :json-data="json_data"
                  :labels="json_label"
                  :csv-title="json_title"
              >
                <i class="fas fa-file-excel"></i>
              </VueJsonToCsv>
            </CButtonGroup>
          </div>
        </CCol>
      </div>
      <CAlert color="success" closeButton :show.sync="dismissCountDownS" fade>{{
          alertMessage
        }}
      </CAlert>
      <div id="people">
        <v-server-table
            :columns="columns"
            :url="listUrl"
            :options="options"
            ref="myTable"
            @loaded="
            exports(self, 'Excel', module, 'Need Reports', self.editId)
          "
        >
          <template #actions="data">
            <CButton
                color="primary"
                v-c-tooltip="$lang.need_report.crud.view"
                v-on:click="viewResponse(data.row.id)"
            >
              <i class="fas fa-eye"></i>
            </CButton>
          </template>
        </v-server-table>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {OpportunityReportList, reportreason} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {required} from "vuelidate/lib/validators";
import required_span from "/src/components/layouts/general/required-span";
import VueJsonToCsv from "vue-json-to-csv";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "NeedReportList",
  mixins: [Mixin],
  components: {
    required_span,
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      ViewResponse: "",
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      reasonOptions: [],
      activePage: 1,
      listUrl: "",
      module: OpportunityReportList,
      moduleReportReason: reportreason,
      need_report: {
        reason: "",
        description: "",
        isActive: "",
      },
      columns: ["reasonName", "createdName", "actions"],
      data: [],
      options: {
        headings: {
          reasonName: "Reason",
          createdName: "Name",
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["name", "isVerified"],
        sortable: ["name", "isVerified"],
        filterable: ["name", "isVerified"],
      },
    };
  },
  validations: {
    opportunity_report: {
      reason: {
        required,
      },
    },
  },
  created() {
    let self = this;
    const id = this.$route.params.id;
    self.listUrl = "/need/report/list/" + id;
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    self.dismissCountDown = 0;
    self.editId = id;
    // self.listUrl = this.listUrl + self.editId;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    this.$root.$on("alert", (arg1, arg2) => {
    });
    axios.get(this.listUrlApi(this.moduleReportReason)).then((response) => {
      response.data.data.map(function (value, key) {
        self.reasonOptions.push({value: value.id, label: value.title});
      });
    });
    store.commit("showLoader", false); // Loader Off
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.need_report.isVerified = 1;
      } else {
        self.need_report.isVerified = 0;
      }
    },
    viewResponse(item) {
      let self = this;
      const id = item;
      self.reportId = item;
      axios
          .get('need/report/view/'+self.reportId)
          .then(function (response) {
            if (response) {
              const responseData = response.data.data;
              self.ViewResponse = responseData.description;
              self.need_report.reason = {
                value: responseData.reasonId,
                label: responseData.reason,
              };
            } else {
              self.data = [];
            }
          });
      self.largeModal = true;
    },
    rowClicked(item) {
      this.$router.push({path: `country/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
    onSubmit() {
      let self = this;
      this.$v.need_report.$touch();
      if (this.$v.need_report.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const postData = {
              reason: self.need_report.reason.value,
              description: self.need_report.description,
              id: self.reportId,
            };
            axios
                .post(this.updateUrlweb(this.module, self.reportId), postData)
                .then(function (response) {
                  self.submitted = true; //Disable Button
                  if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = true; //Disable Button
                });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            const postData = {
              socialLink: self.need_report.SocialLink,
              plateform: self.need_report.platform,
              isVerified: self.need_report.isVerified,
            };
            axios
                .post(this.createUrlWeb(this.module), postData)
                .then(function (response) {
                  self.submitted = true; //Disable Button
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = true; //Disable Button
                });
          }, 500);
        }
      }
    },
  },
};
</script>
